import React from "react";

class FocusMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFocusSelect: false,
      focus: "shop",
      focusObj: props.state.user.sub_branches[0],
      focusValue: props.state.user.sub_branches[0].token,
      institutions: props.state.institutions,
      subBranches: props.state.subBranches,
      wareHouses: props.state.wareHouses,
    };

    this.setCurrentFocus = this.setCurrentFocus.bind(this);
  }

  async setCurrentFocus(event) {
    let value = event.target.value;
    let focus = value.startsWith("ware-") ? "ware" : "shop";
    let focusObj =
      focus === "shop"
        ? this.state.subBranches[value]
        : this.state.wareHouses[value.replace("ware-", "")];
    await this.setState({
      focusValue: value,
      focus: focus,
      focusObj: focusObj,
      showFocusSelect: false,
    });

    this.props.setCurrentFocus(this.state.focus, this.state.focusObj);
  }

  componentDidMount() {
    this.props.setCurrentFocus(this.state.focus, this.state.focusObj);
  }

  render() {
    return (
      <div>
        <div className="d-flex">
          <div className="mr-2">
            <button
              onClick={() => {
                this.setState({ showFocusSelect: !this.state.showFocusSelect });
              }}
              className="button is-info is-round"
            >
              <span className="zmdi zmdi-home"></span>
            </button>
          </div>

          <div className="control">
            {this.state.showFocusSelect ? (
              <div className="select is-info animated fadeIn focus-menu">
                <select
                  value={this.state.focusValue}
                  onChange={this.setCurrentFocus}
                  className="focus-menu"
                >
                  {this.props.state.user.sub_branches.map((sub_branch) => (
                    <option key={sub_branch.token} value={sub_branch.token}>
                      {sub_branch.name}
                    </option>
                  ))}

                  {this.props.state.user.ware_houses.length > 0
                    ? this.props.state.user.ware_houses.map((ware) => (
                        <option key={ware.token} value={"ware-" + ware.token}>
                          {ware.name}
                        </option>
                      ))
                    : ""}
                </select>
              </div>
            ) : (
              <span className="animated fadeIn">
                {this.state.focusObj ? (
                  <span>
                    <span className="is-size-5">
                      {this.state.focusObj.name}
                    </span>
                    <p className="has-text-success online-status">
                      {this.state.focusObj.online ? (
                        <span>Online</span>
                      ) : (
                        <span>
                          {this.state.focusObj.last_sync ? (
                            <span>
                              <span className="mr-2">
                                Last Connection:
                                {new Date(
                                  this.state.focusObj.last_sync
                                ).toDateString()}
                              </span>

                              <span>
                                {new Date(
                                  this.state.focusObj.last_sync
                                ).toLocaleTimeString()}
                              </span>
                            </span>
                          ) : (
                            <span></span>
                          )}
                        </span>
                      )}
                    </p>
                  </span>
                ) : (
                  <span>No Institutions</span>
                )}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FocusMenu;
